"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.years = exports.titles = exports.roles = exports.months = exports.defaultSelectValue = exports.days = void 0;
var titles = [{
  label: 'Mr',
  value: 'Mr'
}, {
  label: 'Mrs',
  value: 'Mrs'
}, {
  label: 'Miss',
  value: 'Miss'
}, {
  label: 'Ms',
  value: 'Ms'
}, {
  label: 'Mx',
  value: 'Mx'
}];
exports.titles = titles;
var roles = [{
  label: 'Admin',
  value: 'ROLE_ADMIN'
}, {
  label: 'User',
  value: 'ROLE_USER'
}];
exports.roles = roles;
var defaultSelectValue = {
  label: 'Please Select...',
  value: ''
};
exports.defaultSelectValue = defaultSelectValue;
var days = Array.from({
  length: 31
}, function (_, i) {
  if ("".concat(i + 1).length === 1) {
    return "0".concat(i + 1);
  } else {
    return (i + 1).toString();
  }
});
exports.days = days;
var months = [{
  label: 'January',
  value: '01'
}, {
  label: 'February',
  value: '02'
}, {
  label: 'March',
  value: '03'
}, {
  label: 'April',
  value: '04'
}, {
  label: 'May',
  value: '05'
}, {
  label: 'June',
  value: '06'
}, {
  label: 'July',
  value: '07'
}, {
  label: 'August',
  value: '08'
}, {
  label: 'September',
  value: '09'
}, {
  label: 'October',
  value: '10'
}, {
  label: 'November',
  value: '11'
}, {
  label: 'December',
  value: '12'
}];
exports.months = months;

function generateArrayOfYears() {
  var max = new Date().getFullYear();
  var min = 1900;
  var years = [];

  for (var i = max; i >= min; i--) {
    years.push(i.toString());
  }

  return years;
}

var years = generateArrayOfYears();
exports.years = years;